import React, { Component } from 'react';
import styled from 'styled-components';
import GoogleMapReact from 'google-map-react';

import mapStyles from './styles';
import { googleMapsAPIKey } from 'src/config/app.conf';
import mapGroups from 'src/data/map';

import GroupMarker from './elements/GroupMarker';
import LocationMarker from './elements/LocationMarker';
import media from '../../styles/media';

class Map extends Component {
  state = {
    activeGroup: null,
    activeMarker: null,
  };

  handleClickGroupMarker = index => {
    this.setState({ activeGroup: index });
  };

  render() {
    const { activeGroup } = this.state;
    return (
      <Root>
        <TextContainer>
          <h4>Work</h4>
          <h2>Past Projects</h2>
          <p>
            Hover over the map markers to see more details about our past
            projects spread out across the Lower Mainland.
          </p>
        </TextContainer>
        <MapContainer>
          <GoogleMapReact
            defaultCenter={{ lat: 49.2142044, lng: -123.0042145 }}
            defaultZoom={9.4}
            bootstrapURLKeys={{ key: googleMapsAPIKey }}
            options={{
              styles: mapStyles,
              disableDefaultUI: true,
            }}
          >
            {mapGroups.map((mapGroup, index) => (
              <GroupMarker
                lat={mapGroup.lat}
                lng={mapGroup.lng}
                onClick={() => this.handleClickGroupMarker(index)}
                active={activeGroup === index}
                count={mapGroup.locations.length}
                key={index}
              />
            ))}
            {activeGroup !== null &&
              mapGroups[activeGroup].locations.map((location, index) => {
                return (
                  <LocationMarker
                    lat={location.lat}
                    lng={location.lng}
                    key={`${activeGroup}-${index}`}
                    delay={`${index * 0.15}s`}
                  >
                    {location.name}
                  </LocationMarker>
                );
              })}
          </GoogleMapReact>
        </MapContainer>
      </Root>
    );
  }
}

const Root = styled.div`
  width: 100%;
`;

const MapContainer = styled.div`
  height: 505px;
  @media (min-width: ${media.md}) {
    height: 720px;
  }
`;

const TextContainer = styled.div`
  @media (min-width: ${media.md}) {
    position: absolute;
    z-index: 998;
    right: 50px;
    h4 {
      color: white;
    }
    p {
      color: white;
    }
    &:before {
      content: '';
      width: 120%;
      height: 120%;
      top: -20px;
      position: absolute;
      left: -20px;
      z-index: -1;
      background: #141414;
      box-shadow: 0 0 20px 0px #000000;
    }
  }
  margin-top: 60px;
  padding-left: 24px;

  h2 {
    width: 110px;
    margin-top: 10px;
    margin-bottom: 25px;
  }
  p {
    width: 285px;
    margin-bottom: 25px;
  }
`;

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js